<form [formGroup]="form" class="form-horizontal" autocomplete="off" novalidate>
  <app-translation-options
    [defaultLanguage]="defaultLanguage"
    [additionalLanguages]="additionalLanguages"
    (openedTranslation)="onOpenedTranslation($event)"
    *ngIf="!createMode && additionalLanguages.length > 0"
  ></app-translation-options>

  <!-- Name -->
  <div class="form-group">
    <label class="col-md-4 control-label">
      <span class="required" [hidden]="viewMode">*</span> {{ 'NAME' | translate }}
    </label>
    <div class="col-md-8">
      <div [hidden]="!viewMode" class="form-label">
        {{ currency.name }}
      </div>
      <div [hidden]="viewMode">
        <input
          type="text"
          class="form-control"
          formControlName="name"
          maxlength="100"
          [readonly]="true"
        />
        <app-form-errors
          [control]="form.controls['name']"
          [formSubmited]="formSubmited"
        ></app-form-errors>
        <app-form-server-errors [error]="serverErrors['name']"></app-form-server-errors>
      </div>
    </div>
  </div>

  <!-- Code -->
  <div class="form-group">
    <label class="col-md-4 control-label">
      <span class="required" [hidden]="viewMode">*</span> {{ 'DESCRIPTION' | translate }}
    </label>
    <div class="col-md-8">
      <div [hidden]="!viewMode" class="form-label">
        {{ currency.code }}
      </div>
      <div [hidden]="viewMode">
        <input
          type="text"
          class="form-control"
          formControlName="code"
          maxlength="5"
          [readonly]="true"
        />
        <app-form-errors
          [control]="form.controls['code']"
          [formSubmited]="formSubmited"
        ></app-form-errors>
        <app-form-server-errors [error]="serverErrors['code']"></app-form-server-errors>
      </div>
    </div>
  </div>

  <!-- Symbol -->
  <div class="form-group">
    <label class="col-md-4 control-label">
      <span class="required" [hidden]="viewMode">*</span> {{ 'SYMBOL' | translate }}
    </label>
    <div class="col-md-8">
      <div [hidden]="!viewMode" class="form-label">
        {{ currency.symbol }}
      </div>
      <div [hidden]="viewMode">
        <input
          type="text"
          class="form-control"
          formControlName="symbol"
          maxlength="35"
          [readonly]="true"
        />
        <app-form-errors
          [control]="form.controls['symbol']"
          [formSubmited]="formSubmited"
        ></app-form-errors>
        <app-form-server-errors [error]="serverErrors['symbol']"></app-form-server-errors>
      </div>
    </div>
  </div>

  <!-- Decimal places -->
  <div class="form-group">
    <label class="col-md-4 control-label">
      <span class="required" [hidden]="viewMode">*</span> {{ 'DECIMAL_PLACES' | translate }}
    </label>
    <div class="col-md-8">
      <div [hidden]="!viewMode" class="form-label">
        {{ currency.decimal_places }}
      </div>
      <div [hidden]="viewMode">
        <mat-select formControlName="decimal_places" placeholder="{{ 'SELECT' | translate }}">
          <mat-option *ngFor="let decimalPlace of decimalPlaces" [value]="decimalPlace">
            {{ decimalPlace }}
          </mat-option>
        </mat-select>
        <app-form-errors
          [control]="form.controls['decimal_places']"
          [formSubmited]="formSubmited"
        ></app-form-errors>
      </div>
    </div>
  </div>

  <div class="form-actions no-wrap">
    <app-item-detail-form-actions
      [createMode]="createMode"
      [disableSaveItem]="sendingForm"
      [isModal]="isModal"
      [sendingForm]="sendingForm"
      [viewMode]="viewMode"
      (canceled)="onCanceled()"
      (edited)="onEditedCurrency()"
      (saved)="onSavedCurrency()"
    >
    </app-item-detail-form-actions>
  </div>
</form>
